import { IPMessageBar, IPText } from 'baseComponents';
import { ReactNode } from 'react';
import { IPMessageBarType } from "baseComponents/MessageBar/IPMessageBar";

interface IWarningMessageProps {
  message?: string;
  onDismiss?: () => void;
  children?: ReactNode;
}

const WarningMessage = (props: IWarningMessageProps) => {
  if (props.message === undefined && props.children === undefined) {
    return null;
  }

  return (
    <IPMessageBar
      messageBarType={IPMessageBarType.warning}
      onDismiss={props.onDismiss}
      isMultiline={true}
      truncated={false}
    >
      {props.message && (
        <IPText styles={{ root: { color: 'black' } }} block>
          {props.message}
        </IPText>
      )}
      {props.children}
    </IPMessageBar>
  );
};

export default WarningMessage;
